import { ReactNode } from "react";

export type BadgeVariant =
  | "delivered"
  | "in-route"
  | "delayed"
  | "failed"
  | "pending"
  | "neutral";

// Pill-style status indicator. Variants map 1:1 to the operational state
// palette so a "delivered" badge anywhere in the app is the same green.
export function Badge({
  variant = "neutral",
  children,
  className = "",
}: {
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
}) {
  const styles: Record<BadgeVariant, string> = {
    delivered:  "bg-state-delivered/10 text-state-delivered border-state-delivered/30",
    "in-route": "bg-state-in-route/10 text-state-in-route border-state-in-route/30",
    delayed:    "bg-state-delayed/10  text-state-delayed border-state-delayed/40",
    failed:     "bg-state-failed/10   text-state-failed border-state-failed/30",
    pending:    "bg-state-pending/15  text-state-pending border-state-pending/40",
    neutral:    "bg-border/40 text-ink border-border",
  };
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium border ${styles[variant]} ${className}`}
    >
      {children}
    </span>
  );
}
